const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_DIGITS_REGEX = /^\d{9,12}$/;

const trimText = (value = "") => value.trim();

export const normalizePhone = (value = "") => value.replace(/\D/g, "");

export const formatAdminPhoneInput = (value = "") =>
  value.replace(/[^\d-\s]/g, "").slice(0, 13);

export const isValidAdminEmail = (value = "") =>
  EMAIL_REGEX.test(trimText(value));

export const isValidAdminPhone = (value = "") =>
  PHONE_DIGITS_REGEX.test(normalizePhone(value));

export const hasRequiredAdminFields = ({ name = "", email = "", phone = "" }) =>
  Boolean(trimText(name) && trimText(email) && normalizePhone(phone));

export const canSubmitAdminInfo = ({
  name = "",
  email = "",
  phone = "",
  isEditing = false,
  personalInfoChecked = false,
  marketingChecked = false,
}) => {
  if (!hasRequiredAdminFields({ name, email, phone })) {
    return false;
  }

  if (!isValidAdminEmail(email) || !isValidAdminPhone(phone)) {
    return false;
  }

  if (isEditing) {
    return true;
  }

  return personalInfoChecked && marketingChecked;
};

export const normalizeAdminInfoPayload = ({
  adminInfoId = null,
  name = "",
  email = "",
  phone = "",
  department = "",
  position = "",
}) => ({
  companyAdminInfoId: adminInfoId,
  adminName: trimText(name),
  adminEmail: trimText(email),
  adminPhone: normalizePhone(phone),
  adminDepartment: trimText(department),
  adminPosition: trimText(position),
});

export const getAdminInfoSubmitErrorMessage = (
  response = {},
  { isEditing = false } = {}
) => {
  if (response.code === 1000) {
    return "필수 정보를 모두 확인해주세요.";
  }

  if (response.code === 1002) {
    return isEditing
      ? "수정할 관리자 정보를 다시 불러와주세요."
      : "관리자 정보를 저장할 수 없습니다. 다시 시도해주세요.";
  }

  if (response.code === 404) {
    return isEditing
      ? "수정할 관리자 정보가 없습니다. 화면을 다시 불러와주세요."
      : "관리자 정보를 찾을 수 없습니다. 다시 시도해주세요.";
  }

  if (
    response.code === 500 &&
    typeof response.message === "string" &&
    /duplicate entry|unique/i.test(response.message)
  ) {
    return "이미 등록된 관리자 정보가 있습니다. 화면을 다시 열어 수정해주세요.";
  }

  if (typeof response.message === "string" && response.message.trim()) {
    return response.message;
  }

  return isEditing
    ? "관리자 정보를 수정하지 못했습니다. 다시 시도해주세요."
    : "관리자 정보를 저장하지 못했습니다. 다시 시도해주세요.";
};
